import { render, staticRenderFns } from "./editPlan.vue?vue&type=template&id=5f709046&scoped=true"
import script from "./editPlan.vue?vue&type=script&lang=js"
export * from "./editPlan.vue?vue&type=script&lang=js"
import style0 from "./editPlan.vue?vue&type=style&index=0&id=5f709046&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f709046",
  null
  
)

export default component.exports